<div class="card-container">
  <div class="title  mb-4">
    <mwp-text-translate [text]="title" [jsonKey]="titleJsonKey" />
  </div>
  @if(navItems?.length > 0) {
    <div class="mb-4">
      <mwp-in-page-nav [navItems]="navItems" />
    </div> 
  }
  @if (headerHTML) {
    <div class="content mb-4">
      <mwp-text-translate [text]="headerHTML" [jsonKey]="headerHTMLJsonKey" [isHTML]=true />
    </div>
  }
</div>